import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth.service';
import { finalize } from 'rxjs/operators';
import { trigger, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class LoginComponent {
  email = '';
  password = '';
  hidePassword = true;
  loading = false;
  errorMessage = '';

  constructor(private auth: AuthService, private router: Router) {}

  login() {
    this.errorMessage = '';

    if (!this.email || !this.password) {
      this.errorMessage = 'Please enter both email and password';
      return;
    }

    this.loading = true;

    this.auth.login({ email: this.email, password: this.password }) // ✅ new login style
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res: any) => {
          // ✅ Save user details & permissions
          this.auth.saveUser(res);
          this.router.navigateByUrl(this.auth.getPreferredLandingRoute());
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = err?.error?.message || 'Invalid email or password';
        },
      });
  }
}
